import React, { Component } from "react";
import { Alert, Container } from "reactstrap";
import { RouterProps } from "../../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, formConfig } from "./PagoAnticipado.form";
import { PagoAnticipadoTable } from "./PagoAnticipado.table";
import { PagoAnticipadoDispatcher } from "../../../containers/comisionesMembresia/pagoAnticipado/PagoAnticipado.dispatcher";
import { PagoAnticipadoStore } from "../../../containers/comisionesMembresia/pagoAnticipado/PagoAnticipado.store";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { Preview } from "../../../../types/IAction";
import {
  GetComisionMembresiaEmpleadosBaja,
  DeleteComisionMembresiaPagoAnticipado
} from "../../../reducers/comisionMembresia";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import { downloadReportePagoAnticipado } from "../../../actions/comisionMembresia";

interface Props
  extends PagoAnticipadoDispatcher,
    PagoAnticipadoStore,
    RouterProps {}

interface State {
  confirmRevertirModalOpen: boolean;
  selectedEmpleadoId: number | null;
  selectedTipoEmpleado: string | null;
  lastPeriodo: string | null;
}

export default class PagoAnticipadoComponent extends Component<Props, State> {
  state: State = {
    confirmRevertirModalOpen: false,
    selectedEmpleadoId: null,
    selectedTipoEmpleado: null,
    lastPeriodo: null
  };

  submit = async (data: { [key in Inputs]: any }) => {
    const { mes, anio } = data;
    const periodo = `${anio || new Date().getFullYear()}-${mes}-01`;

    this.setState({ lastPeriodo: periodo });

    const preview: Preview<
      GetComisionMembresiaEmpleadosBaja
    > = await this.props.getEmpleadosDadosDeBaja(periodo);

    if (!preview.fulfilled) {
      errorNotification(
        preview.gettingEmpleadosDadosDeBajaError ||
          "Error al consultar empleados dados de baja"
      );
    }
  };

  handleDescargarReporte = (idEmpleado: number, tipoEmpleado: string) => {
    if (!this.state.lastPeriodo) {
      errorNotification("Debe realizar una búsqueda primero");
      return;
    }

    downloadReportePagoAnticipado(
      this.state.lastPeriodo,
      idEmpleado,
      tipoEmpleado,
      error => {
        if (!error) {
          successNotification(
            "Reporte de pago anticipado descargado correctamente"
          );
        }
      }
    );
  };

  handleRevertirPago = (idEmpleado: number, tipoEmpleado: string) => {
    this.setState({
      confirmRevertirModalOpen: true,
      selectedEmpleadoId: idEmpleado,
      selectedTipoEmpleado: tipoEmpleado
    });
  };

  confirmRevertirPago = async () => {
    const {
      selectedEmpleadoId,
      selectedTipoEmpleado,
      lastPeriodo
    } = this.state;

    if (!selectedEmpleadoId || !selectedTipoEmpleado || !lastPeriodo) {
      errorNotification("Datos incompletos para revertir el pago");
      return;
    }

    const preview: Preview<
      DeleteComisionMembresiaPagoAnticipado
    > = await this.props.deletePagoAnticipado(
      lastPeriodo,
      selectedEmpleadoId,
      selectedTipoEmpleado
    );

    if (preview.fulfilled) {
      successNotification(
        preview.pagoAnticipadoRevertido.message ||
          "Pago anticipado revertido correctamente"
      );
      this.setState({
        confirmRevertirModalOpen: false,
        selectedEmpleadoId: null,
        selectedTipoEmpleado: null
      });
      // Recargar la lista
      this.submit({
        mes: lastPeriodo.split("-")[1],
        anio: parseInt(lastPeriodo.split("-")[0])
      });
    } else {
      errorNotification(
        preview.deletingPagoAnticipadoError ||
          "Error al revertir el pago anticipado"
      );
      this.setState({
        confirmRevertirModalOpen: false,
        selectedEmpleadoId: null,
        selectedTipoEmpleado: null
      });
    }
  };

  toggleConfirmModal = () => {
    this.setState({
      confirmRevertirModalOpen: false,
      selectedEmpleadoId: null,
      selectedTipoEmpleado: null
    });
  };

  render() {
    const {
      empleadosDadosDeBaja,
      gettingEmpleadosDadosDeBaja,
      gettingEmpleadosDadosDeBajaError,
      deletingPagoAnticipado
    } = this.props;

    const { confirmRevertirModalOpen, selectedEmpleadoId } = this.state;

    return (
      <Container>
        <Alert color="info" className="mt-5 mb-4">
          <i className="fa fa-info-circle" /> Consulte los empleados dados de
          baja en un periodo específico para generar reportes de comisiones
          anticipadas o revertir los cálculos realizados.
        </Alert>

        <div style={{ margin: "0 15px" }}>
          <FormBuilder
            config={formConfig}
            submit={this.submit}
            loading={gettingEmpleadosDadosDeBaja}
          />
        </div>

        {gettingEmpleadosDadosDeBajaError && (
          <Alert color="danger" className="mt-3">
            <i className="fa fa-exclamation-triangle" />{" "}
            {gettingEmpleadosDadosDeBajaError}
          </Alert>
        )}

        <div className="mt-4">
          <PagoAnticipadoTable
            empleados={empleadosDadosDeBaja || []}
            loading={gettingEmpleadosDadosDeBaja}
            onDescargarReporte={this.handleDescargarReporte}
            onRevertirPago={this.handleRevertirPago}
            deletingPagoAnticipado={deletingPagoAnticipado}
          />
        </div>

        <ConfirmModal
          isOpen={confirmRevertirModalOpen}
          toggle={this.toggleConfirmModal}
          onConfirm={this.confirmRevertirPago}
          title="Confirmar Reversión de Pago Anticipado"
          message={`¿Está seguro que desea revertir el pago anticipado del empleado ${selectedEmpleadoId}? Esta acción desmarcará todas las ventas asociadas.`}
          confirmText="Sí, Revertir"
          cancelText="Cancelar"
          confirmColor="warning"
        />
      </Container>
    );
  }
}
